import { baseAppPath, baseRetiredAppPath } from "../config/GlobalConfig";
import { IConfiguration, IDocumentType, IInfoStep, IOption, IPropositionDetails, MemberStatusType } from "../context/model";

export const SESSION_KEY = "mgpVadCollectifId"
export const AUTH_KEY = "mgpEaAuthId"

type AppUrlsType = {
    validatePage: string;
    bienvenuePage: string;
    infoPersoStep0Page: string;
    infoPersoStep1Page: string;
    infoPersoStep2Page: string;
    infoPersoStep3Page: string;
    infoPersoStep4Page: string;
    infoPersoStep5Page: string;
    infoPersoStep6Page: string;
    infoPersoStep7Page: string;
    infoPersoRecapPage: string;
    infoSanteStep0Page: string;
    infoSanteStep1Page: string;
    infoBeneficiaryStep0Page: string;
    infoBeneficiaryStep1Page: string;
    infoBeneficiaryStep2Page: string;
    infoBancaireStep0Page: string;
    documentsSupplementairesStep0Page: string;
    documentsSupplementairesStep1Page: string;
    infoSignatureStep0Page: string;
    error404Page: string;
    error500Page: string;
    infoSignatureStep1Page: string;
    endPage: string;
    recapPage: string;
    infoSignatureStep2Page: string;
    uploadMobileDocPage: string;
    uploadMobileConfirmPage: string;
    infoOptionsPage: string;
    listInvalidDocumentPage: string;
    uploadDocumentPage: string;
    infoModificationPage: string;
    confirmModificationPage: string;
    postSignatureActionPage: string;
    guarantyPage: string;
    familyDocumentsPage: string;
    infoOldContractPage: string;
    subscriptionPage: string
}

type SessionStorageKeyType = {
    nomenclatures: string;
    accessToken: string;

}

type ErrorMessageType = {
    requiredMsg: string;
    invalidMsg: string;
    invalidAge: string;
    invalidCharactersMsg: string;
    fileTypeMsg: string;
    fileSizeMsg: string;
    invalidEmailMsg: string;
    invalidIBANMsg: string;
    franceIBANMsg: string;
    unconfirmedAllDocs: string;
    invalidRODoc: string,
    invalidDateRODoc: string,
    invalidNIR: string,
    invalidROOrganisation:string,
    invalidRONom: string,
    invalidFrenchMobile: string,
    invalidForeignMobile: string,
    invalidFrenchMobileWithIndicator: string,
    technicalErrorMsg: string,
    invalidName: string,
    invalidBirthdateOfBeneficiary: string,
    documentNotFound: string,
    lowQualityDoc: string
}

export const APP_URLS: AppUrlsType = {
    validatePage: baseAppPath + '/init',
    bienvenuePage: baseAppPath + "/bienvenue",
    infoPersoStep0Page: baseAppPath + "/info-perso/step0",
    infoPersoStep1Page: baseAppPath + "/info-perso/step1",
    infoPersoStep2Page: baseAppPath + "/info-perso/step2",
    infoPersoStep3Page: baseAppPath + "/info-perso/step3",
    infoPersoStep4Page: baseAppPath + "/info-perso/step4",
    infoPersoStep5Page: baseAppPath + "/info-perso/step5",
    infoPersoStep6Page: baseAppPath + "/info-perso/step6",
    infoPersoStep7Page: baseAppPath + "/info-perso/step7",
    infoPersoRecapPage: baseAppPath + "/info-perso/recap",
    infoBeneficiaryStep0Page: baseAppPath + "/info-beneficiaire/step0",
    infoBeneficiaryStep1Page: baseAppPath + "/info-beneficiaire/step1",
    infoBeneficiaryStep2Page: baseAppPath + "/info-beneficiaire/step2",
    infoOptionsPage: baseAppPath + "/info-beneficiaire/options",

    infoSanteStep0Page: baseAppPath + "/info-sante/step0",
    infoSanteStep1Page: baseAppPath + "/info-sante/step1",
    infoBancaireStep0Page: baseAppPath + "/info-bancaire/step0",
    documentsSupplementairesStep0Page: baseAppPath + "/documents-supplementaires/step0",
    documentsSupplementairesStep1Page: baseAppPath + "/documents-supplementaires/step1",
    infoSignatureStep0Page: baseAppPath + "/info-signature/step0",
    error404Page: baseAppPath + "/error-404",
    error500Page: baseAppPath + "/error-500",
    infoSignatureStep1Page: baseAppPath + "/info-signature/step1",
    endPage: baseAppPath + "/end",
    recapPage: baseAppPath + "/recapitulatif",
    infoSignatureStep2Page: baseAppPath + "/info-signature/step2",
    uploadMobileDocPage: baseAppPath + "/upload-doc",
    uploadMobileConfirmPage: baseAppPath + "/upload-doc/done",
    listInvalidDocumentPage: baseAppPath + "/documents/all",
    uploadDocumentPage: baseAppPath + "/documents/upload",
    infoModificationPage: baseAppPath + "/signature/correctif-info/step0",
    confirmModificationPage: baseAppPath + "/signature/correctif-info/step1",
    postSignatureActionPage: baseAppPath + "/signature/action",
    guarantyPage: baseAppPath + "/garantie",
    familyDocumentsPage: baseAppPath + "/justificatif-familial",
    infoOldContractPage: baseAppPath + "/info-old-contract",
    subscriptionPage: baseAppPath + "/subscription"
}


export const ERROR_MESSAGES: ErrorMessageType = {
    requiredMsg: "Veuillez renseigner cette information",
    invalidMsg: "L'information renseignée semble incorrecte",
    invalidAge: "Cet ayant droit n'est pas éligible en raison de son âge.",
    invalidCharactersMsg: "Les caractères spéciaux ne sont pas autorisés.",
    fileTypeMsg: "Format de fichier non valide. Veuillez télécharger un fichier type pdf, png, jpg, ou jpeg",
    fileSizeMsg: "La taille de fichier ne peut pas dépasser 4 MB.",
    invalidEmailMsg: "Votre email est invalide.",
    invalidIBANMsg: "Votre IBAN est invalide.",
    franceIBANMsg: "Seules les domiciliations bancaires en France sont autorisées.",
    unconfirmedAllDocs: "Tous les documents devraient avoir été lus et acceptés.",
    invalidRODoc: "Nous n’avons pas réussi à identifier le document. Nous vous invitons à nous le transmettre sous un autre format ou à saisir vos données. ",
    invalidDateRODoc: "Votre attestation de droits à l’assurance maladie n’est plus valable. Vous devez télécharger une attestation de droits à jour. ",
    invalidNIR: "Nous n’avons pas réussi à identifier votre numéro de sécurité sociale sur le document. Nous vous invitons à vous assurer qu’il s’agit bien de votre attestation de droits à l’assurance maladie.",
    invalidROOrganisation: "« Nous n’avons pas réussi à identifier votre organisme de rattachement sur le document. Votre attestation de droits à l’assurance maladie doit être lisible et à jour. ",
    invalidRONom : "Nous n'avons pas réussi à identifier votre nom sur le document. Nous vous invitons à vous assurer qu’il s’agit bien de votre attestation de droits à l’assurance maladie.",
    invalidFrenchMobile: 'Pour la France métropolitaine, le numéro de téléphone doit commencer par 06 ou 07 et comporter 10 chiffres. Si non, veuillez cocher la case "Numéro hors France métropolitaine".',
    invalidForeignMobile: "Pour un numéro hors France métropolitaine, veuillez saisir 00 ou + suivi de l'indicatif et du numéro.",
    invalidFrenchMobileWithIndicator: 'Pour la France métropolitaine, veuillez décocher la case "Numéro hors France métropolitaine", puis renseigner votre numéro de téléphone.',
    technicalErrorMsg: "Une erreur technique est survenue.",
    invalidName: "Les caractères spéciaux ne sont pas autorisés.",
    invalidBirthdateOfBeneficiary: "Vous ne pouvez pas ajouter ce ayant droit durant votre parcours d'affiliation. Nous vous invitons à les ajouter une fois votre affiliation finalisée, sur votre espace adhérent.",
    documentNotFound:  "Le fichier ne peut être ouvert. Il est corrompu. Merci de le supprimer et de retélécharger un nouveau.",
    lowQualityDoc: "Votre document est invalide ou de faible qualité. Veuillez télécharger un autre."
}

export const SESSION_STORAGE_KEYS: SessionStorageKeyType = {
    nomenclatures: "vadc_nomenclature_",
    accessToken: "vadc_id"
}

export const MAX_SMALL_MOBILE_WIDTH = 768;
export const MAX_MOBILE_WIDTH = 1064;

export const PSC_DATE = '2026-01-01';

export const CIVILITY_MONSIEUR_CODE = "278110002";
export const CIVILITY_MADAME_CODE = "278110000";


export const ALL_INFO_STEPS = [
    {code: "DEMANDE_INFO", path: APP_URLS.infoPersoStep0Page, category: 'DEMANDE', label: "Votre couverture mutuelle", state: 'INACTIVE', percentage: '10%'},
    {code: "PERSO_IDENTITE", path: APP_URLS.infoPersoStep1Page, category: 'PERSONAL', label: "Mon identité", state: 'INACTIVE', percentage: '15%'},
    {code: "PERSO_ADRESSE", path: APP_URLS.infoPersoStep2Page, category: 'PERSONAL', label: "Mon adresse", state: 'INACTIVE', percentage: '20%'},
    {code: "PERSO_INFO_SANTE", path: APP_URLS.infoPersoStep3Page, category: 'PERSONAL', label: "Mon attestation de droits à l'Assurance maladie", state: 'INACTIVE', percentage: '25%'},
    {code: "PERSO_COORDONNES_BANCAIRES", path: APP_URLS.infoPersoStep4Page, category: 'PERSONAL', label: "Mes coordonnées bancaires", state: 'INACTIVE', percentage: '30%'},
    {code: "PERSO_COORSONNES", path: APP_URLS.infoPersoStep5Page, category: 'PERSONAL', label: "Mes modalités de contact", state: 'INACTIVE', percentage: '35%'},
    {code: "PERSO_PIECE_IDENTITE", path: APP_URLS.infoPersoStep6Page, category: 'PERSONAL', label: "Mon justificatif d'identité", state: 'INACTIVE', percentage: '45%'},
    {code: "PERSO_COTISATION", path: APP_URLS.infoPersoStep7Page, category: 'PERSONAL', label: "Ma cotisation de base", state: 'INACTIVE', percentage: '50%'},
    {code: "PERSO_RECAP", path: APP_URLS.infoPersoRecapPage, category: 'PERSONAL', label: "Mon récapitulatif", state: 'INACTIVE', percentage: '55%'},
    {code: "AD_AJOUT", path: APP_URLS.infoBeneficiaryStep0Page, category: 'BENEFICIARY', label: "Mon choix", state: 'INACTIVE', percentage: '60%'},
    {code: "AD_INFO_SANTE", path: APP_URLS.infoBeneficiaryStep1Page, category: 'BENEFICIARY', label: "Les attestations de droits de mes proches", state: 'INACTIVE', percentage: '60%'},
    {code: "AD_BENE", path: APP_URLS.infoBeneficiaryStep2Page, category: 'BENEFICIARY', label: "Mes ayants droit", state: 'INACTIVE', percentage: '65%'},
    {code: "JUSTIFICATIFS", path: APP_URLS.familyDocumentsPage, category: 'BENEFICIARY', label: "Mon justificatif de situation familiale", state: 'INACTIVE', percentage: '72%'},
    {code: "GUARANTY", path: APP_URLS.guarantyPage, category: 'GUARANTY', label: "Ma couverture", state: 'INACTIVE', percentage: '72%'},
    {code: "INFO_OLD_CONTRACT", path: APP_URLS.infoOldContractPage, category: 'SIGNATURE', label: "Résiliation de votre complémentaire santé", state: 'INACTIVE', percentage: '75%'},
    {code: "CONFIRME", path: APP_URLS.recapPage, category: 'SIGNATURE', label: "Mon récapitulatif", state: 'INACTIVE', percentage: '75%'},
    {code: "SIGNATURE_DOCS_PRECONTRACTUELS", path: APP_URLS.infoSignatureStep0Page, category: 'SIGNATURE', label: "Mes documents précontractuels", state: 'INACTIVE', percentage: '80%'},
    {code: "SIGNATURE_CODE_AUTHENTICATION", path: APP_URLS.infoSignatureStep1Page, category: 'SIGNATURE', label: "Signature du contrat", state: 'INACTIVE', percentage: '85%'},
    {code: "SIGNATURE_DOCS_SIGNES", path: APP_URLS.infoSignatureStep2Page, category: 'SIGNATURE', label: "Mes documents signés", state: 'INACTIVE', percentage: '90%'},
    {code: "DOC_LISTE", path: APP_URLS.listInvalidDocumentPage, category: 'SIGNATURE', label: "Mes justificatifs", state: 'INACTIVE', reviewMode: true},
    {code: "BIENVENUE", path: APP_URLS.bienvenuePage, label: "Bienvenue", state: 'INACTIVE'},
    {code: "INIT", path: APP_URLS.validatePage, label: "Initiation du parcours...", state: 'INACTIVE'},
    {code: "ERREUR_404", path: APP_URLS.error404Page, label: "Error 404", state: 'INACTIVE'},
    {code: "ERREUR_500", path: APP_URLS.error500Page, label: "Error 500", state: 'INACTIVE'},
    {code: "FIN", path: APP_URLS.endPage, label: "Fin du parcours", category: 'SIGNATURE', state: 'INACTIVE'},
    {code: "UPLOAD_MOBILE_DOC", path: APP_URLS.uploadMobileDocPage, label: "Téléchargement du document", state: 'INACTIVE'},
    {code: "UPLOAD_MOBILE_CONFIRM", path: APP_URLS.uploadMobileConfirmPage, label: "Confirmation du téléchargement de document", state: 'INACTIVE'},
    
    
] as IInfoStep[];

export const PROPOSITION_DOC_TYPES = [
    {code: 'SOCIAL_SECURITY_CERTIFICATE', fileName: 'attestationVitale', label: 'Attestation de droits', category: 'social-security'},
    {code: 'SOCIAL_SECURITY_CERTIFICATE_BENEFICIARY', fileName: 'attestationVitaleAyantsDroit', label: 'Attestation de droits - Ayants droit', category: 'social-security'},
    {code: 'RIB', fileName: 'rib', label: 'Relevé d\'Identité Bancaire', category: 'rib'},
    {code: 'RETIRED_PENSION_PROOF', fileName: 'justificatifPension', label: 'Justificatif de pension de retraite', category: "family"},
    {code: 'LAST_EMPLOYER_PROOF', fileName: 'justificatifDernierEmployeur', label: 'Justificatifs du dernier employeur', category: 'family'},
    {code: 'FAMILY_RECORD_BOOK', fileName: 'livretDeFamille', label: 'Livret de famille', category: "family"},
    {code: 'PACS', fileName: 'pacs', label: 'Pacs', category: "family", displayLabel: 'Attestation Pacs'},
    {code: 'COMMON_LIVE_PROOF', fileName: 'attestationVieCommune', label: 'Attestation de vie commune et justificatif de domicile commun', category: "family"},
    {code: 'COMMON_ADDRESS_PROOF', fileName: 'justificatifDomicileCommun', label: 'Justificatif de domicile commun', category: "family"},
    {code: 'PASSPORT', fileName: 'passeport', label: 'Passeport', category: "identity"},
    {code: 'CNI', fileName: 'pieceIdentite', label: 'Pièce d\'identité', category: "identity"},
    {code: 'CST', fileName: 'titreDeSejour', label: 'Carte de séjour', category: "identity"},
    {code: 'SCHOOL_CERTIFICATE', fileName: 'certificatScolarite', label: 'Certificat de scolarité', category: "family"},
    {code: 'CHILD_HANDICAP_PROOF', fileName: 'justificatifEnfantHandicap', label: 'Justificatif de reconnaissance de handicap', category: "family"},
] as IDocumentType[];

export const COUNTRY_FRANCE_ID = "fe80e0a4-e9e4-e311-8974-f0921c1065a0";

export const FAMILY_SITUATION_PACS_CODE = "278110006";
export const FAMILY_SITUATION_MARIE_CODE = "278110003";

type AppRetirementUrlsType = {
    validatePage: string;
    bienvenuePage: string;
    situationPage: string;
    besoinPage: string;
    guarantyPage: string;
    infoIdentityPage: string;
    infoAddressPage: string;
    infoContactPage: string;
    infoOldContractPage: string;
    infoBankPage: string;
    infoAttestationROPage: string;
    infoAttestationROBeneficiaryPage: string;
    infoBeneficiaryPage: string;
    infoIdentityDocPage: string;
    infoRetirementDocPage: string;
    infoLastEmployeeDocPage: string;
    infoFamilyDocPage: string;
    retirementRecapPage: string;
    infoSignatureDocumentPage: string;
    infoSignatureConfirmPage: string;
    infoSignatureDonePage: string;
    endPage: string;
    postSignatureActionPage: string;
    listInvalidDocumentPage: string;
    uploadDocumentPage: string;
    infoModificationPage: string;
    confirmModificationPage: string;
}


export const APP_RETIREMENT_URLS: AppRetirementUrlsType = {
    validatePage: baseRetiredAppPath + '/init',
    bienvenuePage: baseRetiredAppPath + "/bienvenue",
    situationPage: baseRetiredAppPath + "/ma-situation",
    besoinPage: baseRetiredAppPath + "/mes-besoins",
    guarantyPage: baseRetiredAppPath + "/garantie",
    infoIdentityPage: baseRetiredAppPath + "/votre-identite",
    infoAddressPage: baseRetiredAppPath + "/votre-adresse",
    infoContactPage: baseRetiredAppPath + "/vos-modalites-de-contact",
    infoOldContractPage: baseRetiredAppPath + "/resiliation-votre-mutuelle",
    infoBankPage: baseRetiredAppPath + "/vos-coordonnees-bancaires",
    infoAttestationROPage: baseRetiredAppPath + "/votre-attestation-de-droits",
    infoAttestationROBeneficiaryPage: baseRetiredAppPath + "/attestation-de-droits-de-vos-proches",
    infoBeneficiaryPage: baseRetiredAppPath + "/declarez-vos-ayants-droit",
    infoIdentityDocPage: baseRetiredAppPath + "/telechargez-justificatif-identite",
    infoRetirementDocPage: baseRetiredAppPath + "/telechargez-pension-de-retraite",
    infoLastEmployeeDocPage: baseRetiredAppPath + "/telechargez-lastemployee",
    infoFamilyDocPage: baseRetiredAppPath + "/telechargez-justificatif-familiale",
    retirementRecapPage: baseRetiredAppPath + "/recapitulatif",
    infoSignatureDocumentPage: baseRetiredAppPath + "/signature/vos-documents-precontractuels",
    infoSignatureConfirmPage: baseRetiredAppPath + "/signature/confirmer",
    infoSignatureDonePage : baseRetiredAppPath + "/signature/finir-la-confirmation",
    endPage: baseRetiredAppPath + "/finaliser",
    postSignatureActionPage: baseRetiredAppPath + "/signature/action",
    listInvalidDocumentPage: baseRetiredAppPath + "/documents/all",
    uploadDocumentPage: baseRetiredAppPath + "/documents/upload",
    infoModificationPage: baseRetiredAppPath + "/signature/correctif-info/step0",
    confirmModificationPage: baseRetiredAppPath + "/signature/correctif-info/step1",
}

export const ALL_INFO_RETIREMENT_STEPS = [
    {code: "SITUATION", path: APP_RETIREMENT_URLS.situationPage, category: 'SITUATION', label: "Je renseigne ma situation", state: 'INACTIVE', percentage: '10%'},
    {code: "BESOIN", path: APP_RETIREMENT_URLS.besoinPage, category: 'BESOIN', label: "Je définis mes besoins", state: 'INACTIVE', percentage: '15%'},
    {code: "GUARANTY", path: APP_RETIREMENT_URLS.guarantyPage, category: 'GUARANTY', label: "Ma couverture", state: 'INACTIVE', percentage: '72%'},
    {code: "INFO_IDENTITY", path: APP_RETIREMENT_URLS.infoIdentityPage, category: 'INFO', label: "Complétez votre identité", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_ADDRESS", path: APP_RETIREMENT_URLS.infoAddressPage, category: 'INFO', label: "Complétez votre adresse", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_CONTACT", path: APP_RETIREMENT_URLS.infoContactPage, category: 'INFO', label: "Confirmez vos modalités de contact", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_OLD_CONTRACT", path: APP_RETIREMENT_URLS.infoOldContractPage, category: 'INFO', label: "Résiliation de votre mutuelle", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_BANK", path: APP_RETIREMENT_URLS.infoBankPage, category: 'INFO', label: "Vos coordonnées bancaires", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_ATTES_RO", path: APP_RETIREMENT_URLS.infoAttestationROPage, category: 'INFO', label: "Accélérez vos remboursements", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_ATTES_BENE", path: APP_RETIREMENT_URLS.infoAttestationROBeneficiaryPage, category: 'INFO', label: "Les attestations de droits de mes proches", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_BENE", path: APP_RETIREMENT_URLS.infoBeneficiaryPage, category: 'INFO', label: "Déclarez vos ayants droit", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_IDENTITY_DOC", path: APP_RETIREMENT_URLS.infoIdentityDocPage, category: 'INFO', label: "Pièce d'identité", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_RETIREMENT_DOC", path: APP_RETIREMENT_URLS.infoRetirementDocPage, category: 'INFO', label: "Justificatifs de pension de retraite", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_LASTEMPLOYEE_DOC", path: APP_RETIREMENT_URLS.infoLastEmployeeDocPage, category: 'INFO', label: "Justificatifs du dernier employeur", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_FAMILY_DOC", path: APP_RETIREMENT_URLS.infoFamilyDocPage, category: 'INFO', label: "Justificatifs de famille", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_RECAP", path: APP_RETIREMENT_URLS.retirementRecapPage, category: 'INFO', label: "Récapitulatif", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_SIGNATURE_DOCS_PRECONTRACTUELS", path: APP_RETIREMENT_URLS.infoSignatureDocumentPage, category: 'INFO', label: "Documents précontractuels", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_SIGNATURE_CONFIRM", path: APP_RETIREMENT_URLS.infoSignatureConfirmPage, category: 'INFO', label: "Signature du contrat", state: 'INACTIVE', percentage: '75%'},
    {code: "INFO_SIGNATURE_SIGNED_DOCS", path: APP_RETIREMENT_URLS.infoSignatureDonePage, category: 'INFO', label: "Documents signés", state: 'INACTIVE', percentage: '75%'},
    {code: "DOC_LISTE", path: APP_RETIREMENT_URLS.listInvalidDocumentPage, category: 'INFO', label: "Mes justificatifs", state: 'INACTIVE', reviewMode: true},

] as IInfoStep[];


export const initProposition = {
        propositionId: "",
        propositionName: "",
        statusCode: 0,
        stateCode: 0,
        statusLabel: '',
        stateLabel: '',
        effectiveDate: '',
        signatureDate: new Date(),
        createdDate: new Date(),
        subscriptionUrl: '',
        priceId: '',
        priceLabel: '',
        affiliationType: 0,
        affiliationTypeLabel: '',
        contact: {
            contactId: "",
            administrativeNumber: '',
            firstName: '',
            lastName: '',
            birthDate: null,
            email: '',
            memberNumber: '',
            civilityCode: '',
            civilityLabel: '',
            birthName: '',
            birthPlace: '',
            familySituationCode: 0,
            familySituationLabel: '',
            nir: '',
            nirKey: '',
            regimeCode: '',
            regimeLabel: '',
            address: '',
            additionalAddress: '',
            buildingName: '',
            city: '',
            postalCode: '',
            lieudit: '',
            countryId: '',
            countryLabel: '',
            hiringDate: new Date(),
            radiatedDate: new Date(),
            phoneNumber: '',
            isForeignMobile: null,
            cspIndex: 0,
            cspIndexLabel: '',
            companyIndex: '',
            companyGrade: '',
            attachmentOrganization: '',
            teletranmissionRefuse: '',
            departmentCode: '',
            alsaceMoselleRegime: '',
        },
        principalContractId: '',
        principalProductId: '',
        principalProductName: '',
        iban: '',
        bankingHolder: '',
        totalAmount: 0,
        beneficiaries: [],
        configuration: {} as IConfiguration,
        documents: [],
        ribHolderConfirm: false,
        retirementDate: '',
        currentStep: '',
        offerCode: '',
        salaryIndex: 0,
        increasedIndex: '',
        mainStep: '',
        companyLabel: '',
        retiredCoveragesInfo : {
            nonRefundingPayment:3,
            budget: 0,
            recommendScore: ''
        }
} as IPropositionDetails;

// export const DEFAULT_CONTRACT_ID = "81a512ab-d8ac-ef11-b8e8-000d3a6634d4";
export const DEFAULT_CONTRACT_ID = "41a815ea-5a53-f011-a1ff-005056adbd29"; //contract number: CM00000040
export const DEFAULT_COMPANY_ID = "86ccda64-1a9d-ef11-8a69-7c1e523783a8";
export const DEFAULT_PRODUCT_ID = "909d2e94-2e95-ef11-8a69-002248a40d1c";

export const MARRIED_FAMILY_SITUATION_CODE = '278110003'
export const RETIRED_TYPE_CODE = 284500004;

export const PENSION_SERVICE_OPTIONS = [
    {
        code: "220",
        label: "IRCANTEC"
    },
    {
        code: "221",
        label: "SRE"
    }
] as IOption[]

export const nonRefungdingPaymentLevelOptions = [
    {level: 1, label: 'Faible'},
    {level: 2, label: 'Peu élevé'},
    {level: 3, label: 'Modéré'},
    {level: 4, label: 'Elevé'},
    {level: 5, label: 'Très élevé'}
]
export const budgetLevelOptions = [
    {level: -1, label: 'Faible'},
    {level: 0, label: 'Modéré'},
    {level: 1, label: 'Important'},
 
]

export const ATTEMPT_VALIDATE_DOB = 5;

export const SUPPORT_CONTACT = "0969360000"

export const SUBSCRIPTION_ERROR_MESSAGE = {
    "NOT_FOUND": "Nous n'avons pas pu vous identifier. Veuillez vérifier les données saisies puis contacter un conseiller.",
    "FOUND_NO_AFFILIATION": "Vous n'avez pas de parcours d'affiliation. Veuillez vérifier auprès de votre employeur que la demande d'affiliation a bien été transmise à La MGP ou contacter un conseiller.",
    "AFFILIATED_WITH_ACCOUNT": "Vous êtes bien affilié au contrat collectif santé. Vous pouvez désormais réaliser vos démarches depuis votre espace adhérent : modifier vos coordonnées personnelles et options, ajouter ou supprimer vos ayants droits.",
    "PROPOSITION_AFFILIATION_OFFICE": `Vous n'avez pas procédé à votre affiliation au contrat collectif santé souscrit par votre employeur auprès de la MGP.
    \nEn conséquence, vous allez être affilié automatiquement à ce même contrat.
    \nNous vous invitons à venir vous connecter ici sous 48h afin de créer votre espace adhérent pour mettre à jour vos données personnelles.
    \nCette démarche est essentielle car à défaut, vous ne pourrez pas être remboursé de vos dépenses de santé ni bénéficier de tous les services inclus dans votre contrat
    `,
    "PAPER_FORMULA": "Vous n'avez pas de parcours personnalisé. Si vous êtes agent affecté à l'étranger ou agent sans rémunération, veuillez-vous référer aux modalités d'affiliation prévues dans votre situation.",
    "WAITING_VALIDATION": "Votre avez finalisé votre parcours d'affiliation. Vous serez bientôt notifié par mail du traitement de votre dossier par nos services. Nous vous invitons à patienter."
}

export const MAP_SUBSCRIPTION_MESSAGE: Map<any, any> = new Map([
    [ MemberStatusType.NOT_FOUND, SUBSCRIPTION_ERROR_MESSAGE.NOT_FOUND],
    [ MemberStatusType.FOUND_NO_AFFILIATION, SUBSCRIPTION_ERROR_MESSAGE.FOUND_NO_AFFILIATION],
    [ MemberStatusType.AFFILIATED_WITH_ACCOUNT, SUBSCRIPTION_ERROR_MESSAGE.AFFILIATED_WITH_ACCOUNT],
    [ MemberStatusType.PROPOSITION_AFFILIATION_OFFICE, SUBSCRIPTION_ERROR_MESSAGE.PROPOSITION_AFFILIATION_OFFICE],
    [ MemberStatusType.PAPER_FORMULA, SUBSCRIPTION_ERROR_MESSAGE.PAPER_FORMULA],
    [ MemberStatusType.WAITING_VALIDATION, SUBSCRIPTION_ERROR_MESSAGE.WAITING_VALIDATION]
]);


export const nonEditableFieldsMessage = "Les données non modifiables affichées ci-dessous sont celles dont nous disposons à ce jour. Si vous constatez un changement de situation ou une erreur, nous vous invitons à les actualiser sur votre espace adhérent."

export const dataEditableByAdvisor = "Les données non modifiables affichées ci-dessous sont celles dont nous disposons à ce jour. Si vous constatez un changement de situation ou une erreur, nous vous invitons à contacter un conseiller."